const isString = data => {
  const trimmedData = data.trim();
  if (trimmedData.length > 0) {
    return typeof data === 'string' || data instanceof String;
  }
  return false;
};

export default isString;
